import styled from 'styled-components'
import { ButtonBase, DialogContent, Paper, styled as muiStyled } from '@mui/material/'

// BP : Business Portal

// the widget with both event booking calendar and list of booked events :

export const BPEventsWidgetParent = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  margin-bottom: 20px;
  gap: 27px;
  @media (min-width: 1080px) {
    flex-direction: row;
  }
`

//-------------------------------------------------------------------

// the widget of event booking calendar :

export const BPEventCalendarParent = styled.div`
  background: #e3ebff;
  border-radius: 21px;
  width: 100%;
  padding: 35px;
  display: flex;
  flex-direction: column;
  gap: 30px;
  align-items: center;
  @media (min-width: 1080px) {
    padding: 45px;
  }
`

export const BPCalendarContainer = styled.div`
  width: 100%;
  max-width: 350px;
  flex-shrink: 0;
`

export const BPCalendarSeparator = styled.div`
  height: 2px;
  width: 100%;
  background: #fff;
`

export const BPCalendarDateHeading = styled.div`
  color: #222;
  font-size: 14px;
  font-weight: 500;
`
export const BPAlreadyBookedEventHeading = styled.div`
  color: #e3e3e3;
  font-size: 14px;
  font-weight: 500;
`

function EventListItemStyles({ theme }) {
  return `
display: flex;
flex-direction: column;
gap:5px;
width: 100%;
align-items: start;
padding: 10px;
`
}

export const BPAvailableEventItem = muiStyled(ButtonBase)(EventListItemStyles)
export const BPBookedEventItem = muiStyled('div')(EventListItemStyles)

export const BPAvailableEventHighlight = styled.div`
  color: #2f60da;
  font-size: 14px;
  font-weight: 500;
`
export const BPAlreadyBookedEventHighlight = styled.div`
  color: #7b9ae9;
  font-size: 14px;
  font-weight: 500;
`
export const BPAvailableEventSecondary = styled.div`
  color: #666666;
  font-size: 13px;
  font-weight: 500;
`
export const BPAlreadyBookedEventSecondary = styled.div`
  color: #9f9f9f;
  font-size: 13px;
  font-weight: 500;
`
export const BPAlreadyBookedEventAssignButton = muiStyled(ButtonBase)`
  background: #7b9ae9;
  font-size: 15px;
  font-weight: 500;
  color: white;
  padding: 5px 10px;
  border-radius: 7px;
`

export const BPBookingDialogPaper = muiStyled(Paper)(
  ({ theme }) => `
  font-family: ${theme.typography.fontFamily};
  width: 100%;
  margin: 0 !important;
  background: transparent;
    max-width: 880px !important;
    min-height: 570px !important;
    @media (min-height: 800px) {
        min-height: 600px !important;
    }
`,
)

export const WebinarBookingAndPaymentContainer = styled.div`
  background: #ffffff;
  border-radius: 6px;
  box-shadow: 0 0.5em 1em -0.125em rgba(10, 10, 10, 0.1), 0 0 0 1px rgba(10, 10, 10, 0.02);
  display: flex;
  flex-direction: column;
  padding: 20px;
  flex-grow: 1;
  @media (min-width: 980px) {
    flex-direction: row;
  }
`

export const StyledWebinarSelectTimeZone = styled.select`
  border: 1px solid #e3e3e3;
  border-radius: 10px;
  font-weight: 500;
  height: 30px;
  padding-left: 5px;
`

export const WebinarDetailsContainer = styled.div`
  display: flex;
  flex-direction: column;
  @media (min-width: 660px) {
    flex-direction: row;
  }
  @media (min-width: 980px) {
    flex-direction: column;
    border-right: 1px solid #e3e3e3;
    max-width: 380px;
  }
`

export const WebinarGiftCodeInputContainer = styled.div`
  height: 34px;
  width: 322.923px;
  flex-shrink: 0;
  border-radius: 9px;
  border: 1.5px solid #d9d9d9;
  margin-top: 53px;
  position: relative;
  overflow: hidden;
  @media (min-width: 768px) {
    width: 100%;
    max-width: 522.923px;
    height: 54px;
    border-radius: 14px;
    margin-top: 73px;
  }
`

export const WebinarDetailsContainerTwo = styled.div`
  border-bottom: 1px solid #e3e3e3;
  padding: 0 0 10px 0;
  @media (min-width: 660px) {
    border-left: 1px solid #e3e3e3;
    width: 50%;
    padding: 0 0 0 20px;
  }
  @media (min-width: 980px) {
    width: auto;
    border-bottom: none;
    border-left: none;
    padding: 0 0 20px 0;
  }
`

export const AddEmployeesToWebinarListItem = muiStyled(ButtonBase)(
  ({ theme }) => `
  display: flex;
  justify-content: flex-start;
  algin-items:center;
  gap: 5px;
  padding: 5px 5px;
  width: 100%;
  border-radius: 7px;
`,
)

export const AddEmployeesDialogPaper = muiStyled(Paper)(
  ({ theme }) => `
  padding: 10px;
  border-radius: 7px;
  width: 100%;
  height: 100%;
  margin: 0px !important;
`,
)

export const AddEmployeesDialogContent = muiStyled(DialogContent)`
  font-family: 'Outfit';
`
export const SearchEmployeesInputContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 10px;
  width: 100%;
  padding: 10px 0;
`

export const AddEmployeesButton = muiStyled(ButtonBase)(
  ({ theme, disabled }) => `
  position: relative;
    display: flex;
    justify-content:center;
    align-items: center;
    padding: 7px 13px;
    gap:7px;
    border-radius: 10px;
    background: ${disabled ? '#D9D9D9' : '#6e63c4'};
    color: white;
    &:hover{
      background-color: ${disabled ? '#D9D9D9' : '#6e71c1'};
    }
    transition: all 150ms ease-in-out;
  `,
)

//-------------------------------------------------------------------

// the widget of list of booked events :

export const BPBookedEventsParent = styled.div`
  border-radius: 21px;
  background: #0f1322;
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding: 35px;
  @media (min-width: 1080px) {
    padding: 45px;
  }
`

export const BPBookedEventsHeading = styled.div`
  color: #fff;
  font-size: 20px;
  font-weight: 600;
  @media (min-width: 1080px) {
    font-size: 27px;
    font-weight: 600;
  }
`

//-------------------------------------------------------------------
